module.exports = __webpack_public_path__ + "static/media/icon_edit_action.ff7d2644.svg";